function stickyheaderLoadInit() {
    var windowScroll = window.scrollY;
    let scrollHeightValue = 0;
    var headerElement = document.querySelector('.main-header-top');
    let header = document.querySelector('header');
    if(header){
    
    let stickyHeader = header.getAttribute('data-sticky-header');
    let stickyHeaderType =  header.getAttribute('data-header-type');
    if (stickyHeader == 'true') {
      headerElement.classList.add('sticky-header-active');
    }
     if (stickyHeaderType == 'always'){
     document.querySelector('body').classList.add("sticky-header-always")  
     }
      
    if (headerElement.querySelector('[data-header-main]')) {
      var headerHeight = headerElement.querySelector('[data-header-main]').getBoundingClientRect().height.toFixed(2);;
      document.querySelector('body').style.setProperty('--headerheight', `${headerHeight}px`);
      scrollHeightValue = scrollHeightValue + headerHeight;
      var outerheight = headerHeight + 50;
    
      if(document.querySelector('.announcement-wrapper')){
          let announcementMain = document.querySelector('.announcement-wrapper');
        let annoucementHeight = announcementMain.getBoundingClientRect().height.toFixed(2);
        document.querySelector('body').style.setProperty('--announcementheight', `${annoucementHeight}px`);
      }
 
     if (window.innerWidth > 991) {
        if (headerElement.querySelector('[transparent="true"]')) {
          document.querySelector('body').style.setProperty('--transparentheaderheight', `${headerHeight}px`);
        } 
      }  
      window.addEventListener('scroll', function () {
        let mainHeader = document.querySelector('header');
        let stickyHeader = mainHeader.getAttribute('data-sticky-header');
       
        if (stickyHeader == 'false') {
          return false;
        }
    
        if (stickyHeader == 'true') {
          if (window.scrollY > 50) {
            headerElement.classList.add('stickytrue');
          } else {
            headerElement.classList.remove('stickytrue');
          }
           if (stickyHeaderType == 'on_scroll'){
               if (mainHeader && stickyHeader == 'true') {
                if (window.scrollY > 50) {
                  if (windowScroll > window.scrollY) {
                    headerElement.classList.remove('sticky-header-hidden');
                  } else {
                    if (!document.querySelector('body').classList.contains('menuopen')) {
                      headerElement.classList.add('sticky-header-hidden');
                    }
                  }
                } else {
                  headerElement.classList.remove('sticky-header-hidden');
                }
              } 
           }
        }
        windowScroll = window.scrollY;
      });
      window.addEventListener('resize', function () {
        setTimeout(function () {
          let headerHeight = headerElement.querySelector('[ data-header-main]').getBoundingClientRect().height.toFixed(2);;
          document.querySelector('body').style.setProperty('--headerheight', `${headerHeight}px`);

          // let annoucementHeight = announcementSection.getBoundingClientRect().height.toFixed(2);;
          // document.querySelector('body').style.setProperty('--announcementheight', `${annoucementHeight}px`);

          if (window.innerWidth > 991) {
            if (headerElement.querySelector('.transparent-true')) {
              document.querySelector('body').style.setProperty('--transparentheaderheight', `${headerHeight}px`);
            }
          }
        }, 500);
      });
    }
    }
  }

 /* hamburger nemu for mobile header */
function mobileHumburgerMenuInit() {
    let mobileHumburgerElements = document.querySelectorAll('[data-hamburger-mobile]');
    let headerMainParent = document.querySelector('header');
    let body = document.querySelector('body');

    Array.from(mobileHumburgerElements).forEach(function(element) {
        element.addEventListener("click", function(event) {
           event.preventDefault();  
          let drawerElement =  element.getAttribute("href");
          let contentDrawerContainer= document.querySelector(drawerElement);
             if(element.classList.contains('active')){
                if (body.classList.contains('mobile-menu-active')) {
                    body.classList.remove('no-scroll', 'mobile-menu-active');
                    contentDrawerContainer.classList.remove('active');
                  element.classList.remove('active');
                }
                
             }else{
                    element.classList.add('active');
                    body.classList.add('no-scroll', 'mobile-menu-active');
                    contentDrawerContainer.classList.add('active');
              } 
        });
        
    })
    window.addEventListener("resize", function() {
        if (window.innerWidth > 991 && body.classList.contains('mobile-menu-active')) {
            body.classList.remove('mobile-menu-active', 'no-scroll');
            contentDrawerContainer.classList.remove('show');
        }
    })
}
function mobileMenuitemsEvent() {

  let mobileMenus = document.querySelectorAll(".mobile-menus-item");
    Array.from(mobileMenus).forEach(function(mobileMenu){
      mobileMenu.addEventListener("click",function(event){
        if(mobileMenu){
          mobileMenu.closest("[data-child-items]").classList.add("active")
        }
        
      })
    })
    let backToNavElemets = document.querySelectorAll("[data-backtonav-items],[data-subbacktonav-items]");
    Array.from(backToNavElemets).forEach(function(navBarbackElement) {
        navBarbackElement.addEventListener("click", function(event) {
          if(event.target.closest('details').hasAttribute("open")){
            event.target.closest('details[open]').removeAttribute("open");
            event.target.closest('[data-child-items].active').classList.remove("active");
            //mobileMenuitemsEvent();
          }      
        })
    })

}

document.addEventListener('DOMContentLoaded',  function (section = document) {
  stickyheaderLoadInit();
  mobileHumburgerMenuInit();
  mobileMenuitemsEvent();
});

document.addEventListener('shopify:section:load',function (section) {
     let sectiontargetHead = section.target;
    stickyheaderLoadInit(sectiontargetHead);
    mobileHumburgerMenuInit(sectiontargetHead);
    mobileMenuitemsEvent(sectiontargetHead);
});

document.addEventListener('click', function(event) {
  const mobileMenu = document.getElementById('mobile-nav-menu');
  const toggleBtn = document.querySelector('[data-hamburger-mobile]');
  
  if (mobileMenu && mobileMenu.classList.contains('active')) {
    const isClickInsideMenu = mobileMenu.contains(event.target);
    const isClickOnToggle = toggleBtn && toggleBtn.contains(event.target);
    
    if (!isClickInsideMenu && !isClickOnToggle) {
      mobileMenu.classList.remove('active');
      document.body.classList.remove('no-scroll', 'mobile-menu-active');
      if (toggleBtn) {
        toggleBtn.classList.remove('active');
      }
    }
  }
});

document.querySelectorAll('.has-mega > a').forEach(function (link) {
  link.addEventListener('click', function (e) {
    e.preventDefault();

    const parent = this.parentElement;

    if (parent.classList.contains('active')) {
      parent.classList.remove('active');
      document.body.classList.remove('no-scroll', 'mega-menu-active');
    } else {
      parent.classList.add('active');
      document.body.classList.add('no-scroll', 'mega-menu-active');
    }
  });
});

document.addEventListener('DOMContentLoaded', function() {

  const hasMega = document.querySelector('.has-mega');

  document.addEventListener('click', function(event) {
    if (!hasMega.contains(event.target) && hasMega.classList.contains('active')) {
      hasMega.classList.remove('active');
      document.body.classList.remove('no-scroll', 'mega-menu-active');
    }
  });

})


document.addEventListener('click', function (event) {
    const link = event.target.closest('a');
    if (!link) return;

    if (!link.closest('#mobile-nav-menu')) return;

    if (link.hasAttribute('data-hamburger-mobile')) return;

    const href = link.getAttribute('href');

    if (link.closest('summary') && (!href || href === '#')) {
        return;
    }

    if (!href || href === '#') return;

    setTimeout(function () {

        const mobileMenu = document.getElementById('mobile-nav-menu');
        const toggleBtn = document.querySelector('[data-hamburger-mobile]');

        if (mobileMenu) {
            mobileMenu.classList.remove('active');
        }

        if (toggleBtn) {
            toggleBtn.classList.remove('active');
        }

        document.body.classList.remove(
            'no-scroll',
            'mobile-menu-active',
            'mega-menu-active'
        );

    }, 200);
});

window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
        closeMobileMenuInstant();
    }
});

function closeMobileMenuInstant() {
    const mobileMenu = document.getElementById('mobile-nav-menu');
    const toggleBtn = document.querySelector('[data-hamburger-mobile]');

    if (mobileMenu) {
        mobileMenu.classList.add('no-animation');
        mobileMenu.classList.remove('active');

        mobileMenu.offsetHeight;

        setTimeout(() => {
            mobileMenu.classList.remove('no-animation');
        }, 0);

        mobileMenu.querySelectorAll('details[open]').forEach(details => {
            details.removeAttribute('open');
        });

        // Remove state active (level menu)
        mobileMenu.querySelectorAll('[data-child-items].active').forEach(el => {
            el.classList.remove('active');
        });
    }

    if (toggleBtn) {
        toggleBtn.classList.remove('active');
    }

    document.body.classList.remove(
        'no-scroll',
        'mobile-menu-active',
        'mega-menu-active'
    );
}